import { FileText, ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import Header from '../components/layout/Header'

const Offer = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-sm text-gray-500 hover:text-primary-600 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            На главную
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
          {/* Заголовок */}
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-primary-50 to-white">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <FileText className="w-5 h-5 text-primary-600" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900">Публичная оферта</h1>
            </div>
            <p className="text-sm text-gray-500">
              на оказание услуг сервиса WB Greenlight
            </p>
          </div>

          {/* Содержание */}
          <div className="p-8 prose prose-gray max-w-none">
            <div className="text-right text-sm text-gray-500 mb-8">
              <p>г. Москва</p>
              <p>Дата публикации: 5 июля 2026 г.</p>
            </div>

            <p className="text-sm text-gray-600 mb-8">
              Самозанятый Курбанов Камран Айтакинович (ИНН 180805638897), именуемый в дальнейшем "Исполнитель",
              предлагает неопределённому кругу лиц (далее — "Заказчик") заключить договор на оказание услуг
              сервиса WB Greenlight на условиях, изложенных ниже.
            </p>

            {/* 1. Термины */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</h2>
              <div className="space-y-3">
                <div>
                  <p className="font-medium text-gray-900">1.1. Сервис</p>
                  <p className="text-gray-600 ml-4">
                    — веб-сайт wb-greenlight.ru и связанные с ним программы, предоставляющие
                    инструменты для проверки карточек товаров на соответствие оферте Wildberries.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">1.2. Пользователь</p>
                  <p className="text-gray-600 ml-4">
                    — физическое или юридическое лицо, зарегистрированное в Сервисе.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">1.3. Тариф</p>
                  <p className="text-gray-600 ml-4">
                    — условия использования Сервиса, определяющие объём доступных функций и лимитов.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">1.4. Проверка</p>
                  <p className="text-gray-600 ml-4">
                    — операция анализа описания карточки товара на соответствие оферте Wildberries.
                  </p>
                </div>
              </div>
            </section>

            {/* 2. Предмет */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">2. ПРЕДМЕТ ДОГОВОРА</h2>
              <div className="space-y-3">
                <div>
                  <p className="font-medium text-gray-900">2.1.</p>
                  <p className="text-gray-600 ml-4">
                    Исполнитель обязуется оказать Заказчику услуги по проверке карточек товаров на соответствие
                    оферте Wildberries с использованием технологий искусственного интеллекта.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">2.2.</p>
                  <p className="text-gray-600 ml-4">
                    Заказчик обязуется оплатить услуги в порядке и на условиях, определённых настоящей Офертой.
                  </p>
                </div>
              </div>
            </section>

            {/* 3. Регистрация */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">3. ПОРЯДОК РЕГИСТРАЦИИ И ИСПОЛЬЗОВАНИЯ</h2>
              <div className="space-y-3">
                <div>
                  <p className="font-medium text-gray-900">3.1.</p>
                  <p className="text-gray-600 ml-4">
                    Для использования Сервиса Заказчик проходит регистрацию, указывая действительный email.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">3.2.</p>
                  <p className="text-gray-600 ml-4">
                    Заказчик несёт ответственность за достоверность предоставленных данных.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">3.3.</p>
                  <p className="text-gray-600 ml-4">
                    Один аккаунт предназначен для использования одним лицом. Передача аккаунта третьим лицам запрещена.
                  </p>
                </div>
              </div>
            </section>

            {/* 4. Тарифы */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">4. ТАРИФНЫЕ ПЛАНЫ И ОПЛАТА</h2>
              <div className="space-y-3">
                <div>
                  <p className="font-medium text-gray-900">4.1.</p>
                  <p className="text-gray-600 ml-4">
                    Сервис предоставляет следующие тарифы:
                  </p>
                  <ul className="list-disc ml-12 mt-1 text-gray-600 space-y-1">
                    <li>"Бесплатный": 0 ₽/мес, 5 проверок в день, базовые функции.</li>
                    <li>"Полный": 299 ₽/мес, безлимитные проверки, полный функционал.</li>
                  </ul>
                </div>
                <div>
                  <p className="font-medium text-gray-900">4.2.</p>
                  <p className="text-gray-600 ml-4">
                    Оплата тарифа "Полный" производится разовым платежом через платёжную систему YooKassa.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">4.3.</p>
                  <p className="text-gray-600 ml-4">
                    Подписка активируется с момента подтверждения оплаты и действует в течение 30 календарных дней.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">4.4.</p>
                  <p className="text-gray-600 ml-4">
                    Возврат денежных средств возможен в течение 14 дней с момента оплаты при условии,
                    что услуги не были использованы (не было ни одной проверки).
                  </p>
                </div>
              </div>
            </section>

            {/* 5. Права и обязанности */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">5. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
              <div className="space-y-3">
                <p className="font-medium text-gray-900">5.1. Исполнитель обязуется:</p>
                <ul className="list-disc ml-12 text-gray-600 space-y-1">
                  <li>Обеспечивать доступность Сервиса 24/7 (за исключением технических работ).</li>
                  <li>Обрабатывать данные Заказчика в соответствии с Политикой конфиденциальности.</li>
                  <li>Не передавать данные третьим лицам без согласия Заказчика.</li>
                </ul>
                <p className="font-medium text-gray-900 mt-3">5.2. Заказчик обязуется:</p>
                <ul className="list-disc ml-12 text-gray-600 space-y-1">
                  <li>Использовать Сервис в соответствии с законодательством РФ.</li>
                  <li>Не использовать Сервис для нарушения правил Wildberries.</li>
                  <li>Не пытаться получить несанкционированный доступ к системе.</li>
                </ul>
              </div>
            </section>

            {/* 6. Ответственность */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">6. ОТВЕТСТВЕННОСТЬ СТОРОН</h2>
              <div className="space-y-3">
                <p className="font-medium text-gray-900">6.1. Исполнитель не несёт ответственности за:</p>
                <ul className="list-disc ml-12 text-gray-600 space-y-1">
                  <li>Решения Wildberries по блокировке карточек Заказчика.</li>
                  <li>Убытки, возникшие из-за использования или невозможности использования Сервиса.</li>
                  <li>Действия третьих лиц, приведшие к нарушению работы Сервиса.</li>
                </ul>
                <div className="mt-3">
                  <p className="font-medium text-gray-900">6.2.</p>
                  <p className="text-gray-600 ml-4">
                    Результаты проверок носят рекомендательный характер и не являются гарантией
                    отсутствия блокировок со стороны Wildberries.
                  </p>
                </div>
              </div>
            </section>

            {/* 7. Споры */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">7. ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ</h2>
              <div className="space-y-3">
                <div>
                  <p className="font-medium text-gray-900">7.1.</p>
                  <p className="text-gray-600 ml-4">
                    Все споры решаются путём переговоров. Претензии направляются на email:{' '}
                    <a href="mailto:kamran@kurbanov.me" className="text-primary-600 hover:text-primary-700">
                      kamran@kurbanov.me
                    </a>.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">7.2.</p>
                  <p className="text-gray-600 ml-4">
                    При невозможности урегулирования спор передаётся на рассмотрение в суд по месту
                    нахождения Исполнителя.
                  </p>
                </div>
              </div>
            </section>

            {/* 8. Срок действия */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">8. СРОК ДЕЙСТВИЯ И ИЗМЕНЕНИЕ ОФЕРТЫ</h2>
              <div className="space-y-3">
                <div>
                  <p className="font-medium text-gray-900">8.1.</p>
                  <p className="text-gray-600 ml-4">
                    Оферта вступает в силу с момента публикации и действует бессрочно.
                  </p>
                </div>
                <div>
                  <p className="font-medium text-gray-900">8.2.</p>
                  <p className="text-gray-600 ml-4">
                    Исполнитель вправе изменять условия Оферты в одностороннем порядке с уведомлением
                    Заказчиков по email не менее чем за 7 дней до вступления изменений в силу.
                  </p>
                </div>
              </div>
            </section>

            {/* 9. Контакты */}
            <section className="mb-4">
              <h2 className="text-xl font-bold text-gray-900 mb-4">9. КОНТАКТНАЯ ИНФОРМАЦИЯ</h2>
              <div className="bg-gray-50 rounded-xl p-6 space-y-2 text-gray-700">
                <p><span className="font-medium text-gray-900">Исполнитель:</span> Самозанятый Курбанов Камран Айтакинович</p>
                <p><span className="font-medium text-gray-900">ИНН:</span> 180805638897</p>
                <p>
                  <span className="font-medium text-gray-900">Email:</span>{' '}
                  <a href="mailto:kamran@kurbanov.me" className="text-primary-600 hover:text-primary-700">
                    kamran@kurbanov.me
                  </a>
                </p>
                <p>
                  <span className="font-medium text-gray-900">Сайт:</span>{' '}
                  <a href="https://wb-greenlight.ru" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700">
                    https://wb-greenlight.ru
                  </a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Offer